import { newsSlugs, vacanciesSlugs } from '@boss/constants/corporate-jobs';
import { ContentPageFields, OverviewPageFields } from '@boss/types/corporate-jobs';

/**
 * Returns the page path for internal links.
 * @function
 * @param page
 * @param locale
 * @returns {string} - Page path
 */

export const getPagePathByEntry = (
  page: ContentPageFields | OverviewPageFields | undefined,
  locale: string,
): string => {
  if (!page) {
    return '/';
  }
  const pageType = page?.__typename;

  if (pageType === 'contentPage') {
    return page.slug;
  }

  if (pageType === 'overviewPage') {
    if (page.type === 'latest-news') {
      return newsSlugs[locale];
    }
    if (page.type === 'vacancies') {
      return vacanciesSlugs[locale];
    }
  }

  return '/';
};

export default getPagePathByEntry;
